import {
  ContentContainer,
  ContentHeader,
  ContentScroll,
  PageTitle,
} from "features/layout/components";

import RenderIf from "common/components/RenderIf";
import useCustomer from "common/datahooks/useCustomer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import OnboardingProgress from "./OnboardingProgress";
import OnboardingVideo from "./OnboardingVideo";
import WelcomeScreen from "./WelcomeScreen";

export default function WorkspaceOnboarding() {
  const isDesktop = useTwBreakpoint("lg");

  const {
    customerInfo: { first_name },
  } = useCustomer();

  return (
    <ContentContainer>
      <RenderIf condition={isDesktop}>
        <ContentHeader>
          <PageTitle />
        </ContentHeader>
      </RenderIf>

      <ContentScroll className="w-full p-4 lg:pt-14 gap-y-4 lg:w-[824px] mx-auto">
        <div className="flex flex-col gap-y-1">
          <h2 className="text-md-bold lg:text-2xl-bold">
            Welcome, {first_name}!
          </h2>
          <p className="text-black-500 text-sm">Let's set up your dashboard</p>
        </div>

        <OnboardingVideo />
        <OnboardingProgress />
        <WelcomeScreen />
      </ContentScroll>
    </ContentContainer>
  );
}
